import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=9f15e7f8&scoped=true"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=9f15e7f8&prod&scoped=true&lang=less"
import style1 from "./newsCenter.vue?vue&type=style&index=1&id=9f15e7f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15e7f8",
  null
  
)

export default component.exports